import i18n from 'vue-i18n';
import Vue from 'vue';
import messages from './messages';

Vue.use(i18n);

export default new i18n({
    locale: 'zh',    // 默认：简中
    //this.$i18n.locale // 通过切换locale的值来实现语言切换
    fallbackLocale: 'zh',//退回：简中
    messages
})